import React, { useState } from "react";
import { toast } from "react-toastify";
import adminPricingService from "./adminPricingService";

const AddPackageModal = ({ onClose, onSuccess }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim() || !description.trim() || !price) {
      toast.error("Name, description, and price are required.");
      return;
    }

    const payload = {
      name,
      description,
      price,
      discount_percentage: discountPercentage || "0.00",
    };

    try {
      setLoading(true);
      await adminPricingService.addPackage(payload);
      toast.success("Package added successfully!");
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Failed to add package:", error);
      toast.error("Error adding package.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-lg">
        <h2 className="text-lg font-semibold mb-4">Add New Package</h2>

        <div className="mb-3">
          <label className="block text-sm font-medium">Name *</label>
          <input
            type="text"
            className="w-full border rounded px-3 py-2"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            maxLength={255}
          />
        </div>

        <div className="mb-3">
          <label className="block text-sm font-medium">Description *</label>
          <textarea
            className="w-full border rounded px-3 py-2"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="block text-sm font-medium">Price (USD) *</label>
          <input
            type="number"
            step="0.01"
            className="w-full border rounded px-3 py-2"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            required
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium">Discount Percentage</label>
          <input
            type="number"
            step="0.01"
            className="w-full border rounded px-3 py-2"
            value={discountPercentage}
            onChange={(e) => setDiscountPercentage(e.target.value)}
          />
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded hover:bg-gray-100"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Package"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPackageModal;
